import { notify } from "@/lib/notify";

/**
 * Box ids are numeric. The anonymized snapshot (staging, sandboxes) replaces them with 32-character hashes until the
 * claim's real documents are downloaded (« Télécharger les pièces réelles »).
 */
export function isNotImported(boxId: string) {
  return /^[0-9a-f]{32}$/.test(boxId);
}

/** False (and says why) when the claim's Box folder cannot be opened: not created yet, or not imported (sandboxes). */
export function isBoxFolderAvailable(boxFolderId: string | null | undefined): boxFolderId is string {
  if (!boxFolderId) {
    notify.error("Le dossier Box n'est pas encore initialisé");
    return false;
  }
  if (isNotImported(boxFolderId)) {
    notify.error(
      "Dossier Box non importé : cliquez sur « Télécharger les pièces réelles » pour créer sa copie de test",
    );
    return false;
  }
  return true;
}

/** Port of utils/open-box-folder.ts (Vue). */
export function openBoxFolder(boxFolderId: string | null | undefined) {
  if (!isBoxFolderAvailable(boxFolderId)) {
    return;
  }
  window.open(`https://upclaim.app.box.com/folder/${boxFolderId}`, "_blank")?.focus();
}

const boxFileUrl = (fileId: string) => `https://upclaim.app.box.com/file/${fileId}`;

/**
 * `preOpenedTab`: tab opened synchronously during the user click, for flows where
 * the file id only arrives after a long mutation — a window.open at that point is
 * popup-blocked, redirecting a pre-opened tab is not.
 */
export function openBoxFile(fileId: string, preOpenedTab?: Window | null) {
  if (isNotImported(fileId)) {
    preOpenedTab?.close();
    notify.error(
      "Fichier Box non importé : cliquez sur « Télécharger les pièces réelles » du dossier pour créer sa copie de test",
    );
    return;
  }
  if (preOpenedTab) {
    preOpenedTab.location.href = boxFileUrl(fileId);
    preOpenedTab.focus();
    return;
  }
  window.open(boxFileUrl(fileId), "_blank")?.focus();
}
